import country from './country'
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';
const form = () => {
    class FormWizard {
        constructor(prop_element = null, prop_currentStepIdx = 0) {
            this.element = prop_element
            this.steps = [...this.element.querySelectorAll('.js-step')]
            this.formControls = [...this.element.querySelectorAll('.js-form-control')]
            this.btnPrev = this.element.querySelector('.js-btn-prev')
            this.btnNext = this.element.querySelector('.js-btn-next')
            this.progressBar = this.element.querySelector('.js-progress-bar')
            this.pr = this.element.querySelectorAll('.roi-steps__item')
                //  this.country = this.element.getElementById('country')
            this.data = [];
            this.country = '';
            this.code = '';
            this.currentStepIdx = prop_currentStepIdx

            this.init()
        }

        init() {
            this.showStep(this.currentStepIdx)
            this.addrooms();
            this.addEvents()
        }

        showStep(prop_stepIdx = 0) {
            const stepIdx = prop_stepIdx;

            this.steps[stepIdx].classList.add('is-active')
            this.btnPrev.classList[stepIdx === 0 ? 'remove' : 'add']('is-active')
            this.btnNext.innerText = this.btnNext.dataset[stepIdx === this.steps.length - 1 ? 'finalStepText' : 'stepText']

            this.updateProgressBar(stepIdx)
        }

        prevNext(prop_value = 0) {
                const value = prop_value

                if (value === 1 && !this.validate()) {
                    return false
                }

                this.steps[this.currentStepIdx].classList.remove('is-active')
                this.currentStepIdx += value


                if (this.currentStepIdx >= this.steps.length) {
                    //////////////////////////////// send form  email //////////////////////////////////////
                    const vdata = new FormData();
                    this.getcountry(this.element.country.value)
                    vdata.append('room', this.getroom(this.element.room.value));
                    vdata.append('check_in', this.element.check_in.value);
                    vdata.append('check_uot', this.element.check_out.value);
                    vdata.append('adults', this.element.adults.value);
                    vdata.append('child', this.element.children.value);
                    vdata.append('country', this.country)
                    vdata.append('phone', this.element.phone.value)
                        /////val step  two
                    vdata.append('fullname', this.element.name.value);
                    vdata.append('phone', this.code + ' ' + this.element.phone.value)
                    vdata.append('email', this.element.Email.value)
                    vdata.append('comfirmail', this.element.confirmEmail.value)
                    vdata.append('messaje', this.element.messaje.value)
                        // key generate ramdom js
                    vdata.append('id', this.keyid(100));

                    fetch('/wp-content/themes/vvhotel/mail/SendRooms.php', {
                            method: 'POST',
                            body: vdata,
                            //  headers: {
                            //      'Content-Type': 'application/json'
                            //  }
                        })
                        .then(res => res.json())
                        .then(({ success }) => {
                            if (success) {
                                this.showStep(0);
                                this.currentStepIdx = 0;
                                this.element.reset();
                                Swal.fire({
                                    icon: 'success',
                                    showConfirmButton: false,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    title: 'Thank you, your reservation was made successfully',
                                    footer: '<a href="https://www.veronicaviewhotel.com/">Go back to start</a>'
                                })
                            } else {
                                this.showStep(0);
                                this.currentStepIdx = 0;

                                Swal.fire({
                                    title: 'Error Sending',
                                    icon: 'error',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                })
                                return false;
                            }
                        }).catch((error) => {
                            console.log(error)
                        })
                    return false
                }

                this.showStep(this.currentStepIdx)
            }
            /////////////////////// ger room title from id ///////////
        getroom(key) {
                const { title } = this.data.find(elemet => elemet.id == key)
                return title.rendered;
            }
            ///////////////////////// get country code + name/////////////////////////////
        getcountry(id) {
                const { dial_code, name_en } = country.find(({ code }) => code === id);

                return (this.code = dial_code, this.country = name_en);
            }
            //////////////////generate key id/////////////////////////////////////
        keyid(length) {
                var result = '';
                var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var charactersLength = characters.length;
                for (var i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            }
            //////////////////////// validate form ////////////////////////////////////
        validate() {
            const currentStepRequiredElements = [...this.steps[this.currentStepIdx].querySelectorAll('.from-validate')]
            let valid = true
            for (let index = 0; index < currentStepRequiredElements.length; index++) {
                if (currentStepRequiredElements[index].getAttribute('term')) {
                    let a = currentStepRequiredElements[index];

                    if (a.checked == false) {
                        a.focus();
                        return valid = false
                    }
                }
                if (currentStepRequiredElements[index].value === null || currentStepRequiredElements[index].value.trim() === '') {
                    currentStepRequiredElements[index].focus();
                    currentStepRequiredElements[index].closest('.js-input-group').classList.add('has-error');
                    return valid = false

                }

            }
            return valid
        }

        clearErrors(e) {
            e.target.closest('.js-input-group').classList.remove('has-error')
        }

        updateProgressBar(prop_stepIdx = 0) {
            const percentage = (prop_stepIdx) / this.steps.length
                //  this.progressBar.style.transform = `scaleX(${percentage === 0 ? '0.01' : percentage})`;
            this.pr[prop_stepIdx].getAttribute('bg') ? this.pr[prop_stepIdx + 1].removeAttribute('bg') : this.pr[prop_stepIdx].setAttribute('bg', 'true');

        }

        addEvents() {
                for (let formControl of this.formControls) {
                    formControl.addEventListener('keyup', this.clearErrors.bind(this))
                    formControl.addEventListener('change', this.clearErrors.bind(this))
                }

                this.btnPrev.addEventListener('click', this.prevNext.bind(this, -1))
                this.btnNext.addEventListener('click', this.prevNext.bind(this, 1))
            }
            /////////////////////// add Room Api Wp GET////////////////////////////////
        addrooms() {
            var room = [];
            var template = "",
                templateroom = "";
            var add = document.getElementById('room'),
                sumary = document.getElementById('sumary')
            fetch('https://www.veronicaviewhotel.com/wp-json/wp/v2/posts?categories=262')
                .then(response => response.json())
                .then(data => {

                    this.data = data;
                    data.forEach(element => {
                        template += `<option  ${element.code == "US" ? 'selected="true"' : ''} value="${element.id}">${element.title.rendered} </option> `
                    });
                    add.insertAdjacentHTML('beforeend', template);
                    console.log(data);
                });
  
        };

    }

    ////////////////////////DOMContentLoaded Js //////////////////////////////
    window.addEventListener('DOMContentLoaded', () => {
            //////////////////////////initial classs form/////////////////////////
            window.formWizardObjs = {}
            const formWizards = [...document.querySelectorAll('.js-form-wizard')]

            if (formWizards.length) {
                for (let formWizard of formWizards) {
                    formWizardObjs[formWizard.id] = new FormWizard(formWizard)
                }
            }
            ////////////////////////////////set country option  value//////////////////////////////////
            let pais = get('#country');
            if (pais) {
                let code_pais = get('#code_country'),
                    templatePais = "",
                    $lag = document.querySelector("meta[property='og:locale']").getAttribute("content");
                country.forEach(element => {
                    //  ban += `<span class="flag ${element.code.toLocaleLowerCase()}"></span>`;
                    if ($lag == "es_ES") {
                        if (element.code == "US") {
                            templatePais += `<option selected value="${element.code}">${element.name_en} </option> `
                            code_pais.innerHTML = element.dial_code;
                            code_pais.insertAdjacentHTML('afterbegin', `<span class="flag ${element.code.toLocaleLowerCase()}"></span>`);
                        } else {
                            templatePais += `<option value="${element.code}">${element.name_en} </option> `
                        }
                    }
                    if ($lag == "en_US") {
                        if (element.code == "US") {
                            templatePais += `<option selected value="${element.code}">${element.name_en} </option> `
                            code_pais.innerHTML = element.dial_code;
                            code_pais.insertAdjacentHTML('afterbegin', `<span class="flag ${element.code.toLocaleLowerCase()}"></span>`);
                        } else {
                            templatePais += `<option value="${element.code}">${element.name_en} </option> `
                        }
                    }

                })
                pais.innerHTML = templatePais;
                //  a.insertAdjacentHTML('beforeend', ban);
                //////////////////////////////// initial choices js ////////////////////////////
                const choices = new Choices(pais);
                /////////////////////////// onchange country /////////////////////////////
                pais.addEventListener('change', () => {
                    country.forEach(element => {
                        if (pais.value == element.code) {
                            code_pais.innerHTML = element.dial_code;
                            code_pais.insertAdjacentHTML('afterbegin', `<span class="flag ${element.code.toLocaleLowerCase()}"></span>`);
                        }
                    })
                })
            }
        })
        /////////////////////// util js///////////
    function get(selector, Root = document) {
        return Root.querySelector(selector);
    }


}

export default form;